import React from 'react';
import { Dashboard, DashboardModal } from '@uppy/react';
import '@uppy/core/dist/style.css';
import '@uppy/dashboard/dist/style.css';
import '@uppy/provider-views/dist/style.css';
import { IFileUpload } from '../../models/components/file-upload';
import Translator from '../../core/i18n';
import { Log } from 'ng2-logger';
import XHRUpload from '@uppy/xhr-upload';
import Uppy from '@uppy/core';
import { FileService } from '../../api/file-service';
import { Notification } from '../../components/notification/main';
import { Common } from '../../core/common';
import { Guid } from 'guid-typescript';
import ReactDOM from 'react-dom';
import { ActivityTypeEnums } from '../../models/enums/ActivityType';
import { Dispatch } from 'redux';
import { IAction, IAppState } from '../../models/action/core';
import { connect } from 'react-redux';

const T = Translator.create();
// let uppy: any = Uppy;
const _common = new Common();
const _fileService = new FileService();

export class CFileUpload extends React.Component<IFileUpload> {
    public uppy: any = Uppy;

    public state = {
        locale: {
            strings: {
                youCanOnlyUploadX: {
                    0: T.t('r_max_file_limit'),
                    1: T.t('r_max_files_limit')
                },
                youCanOnlyUploadFileTypes: T.t('r_fileUpload_youCanOnlyUploadFileTypes'),
                exceedsSize: T.t('r_fileUpload_exceedsSize'),
                failedToUpload: T.t('r_fileUpload_failedToUpload'),
                noInternetConnection: T.t('r_fileUpload_noInternetConnection'),
                connectedToInternet: T.t('r_fileUpload_connectedToInternet'),
                noFilesFound: T.t('r_fileUpload_noFilesFound'),
                selectXFiles: {
                    0: T.t('r_fileUpload_selectXFile'),
                    1: T.t('r_fileUpload_selectXFiles')
                },
                logOut: T.t('r_fileUpload_logOut'),
                filter: T.t('r_fileUpload_filter'),
                resetFilter: T.t('r_fileUpload_resetFilter'),
                actionBtn: T.t('r_fileUpload_actionBtn'),
                uploadButton: T.t('r_fileUpload_youCanOnlyUploadFileTypes'),
                cancel: T.t('r_fileUpload_cancel'),
                back: T.t('r_fileUpload_back'),
                uploadXFiles: {
                    0: T.t('r_fileUpload_uploadXNewFile'),
                    1: T.t('r_fileUpload_uploadXNewFiles')
                },
                uploadXNewFiles: {
                    0: T.t('r_fileUpload_uploadXNewFile'),
                    1: T.t('r_fileUpload_uploadXNewFiles')
                },
                uploadingXFiles: {
                    0: T.t('r_fileUpload_uploadingXFile'),
                    1: T.t('r_fileUpload_uploadingXFiles')
                },
                uploadFailed: T.t('r_fileUpload_uploadFailed'),
                error: T.t('r_fileUpload_error'),
                closeModal: T.t('r_fileUpload_youCanOnlyUploadFileTypes'),
                addMoreFiles: T.t('r_fileUpload_addMoreFiles'),
                addMoreFile: T.t('r_fileUpload_addMoreFile'),
                addingMoreFiles: T.t('r_fileUpload_addingMoreFiles'),
                addingMoreFile: T.t('r_fileUpload_addingMoreFile'),
                dashboardWindowTitle: T.t('r_fileUpload_dashboardWindowTitle'),
                dashboardTitle: T.t('r_fileUpload_dashboardTitle'),
                copyLinkToClipboardSuccess: T.t('r_fileUpload_copyLinkToClipboardSuccess'),
                copyLinkToClipboardFallback: T.t('r_fileUpload_copyLinkToClipboardFallback'),
                copyLink: T.t('r_fileUpload_copyLink'),
                fileSource: T.t('r_fileUpload_fileSource'),
                done: T.t('r_fileUpload_done'),
                removeFile: T.t('r_fileUpload_removeFile'),
                editFile: T.t('r_fileUpload_editFile'),
                editing: T.t('r_fileUpload_editing'),
                edit: T.t('r_fileUpload_edit'),
                finishEditingFile: T.t('r_fileUpload_finishEditingFile'),
                myDevice: T.t('r_fileUpload_myDevice'),
                dropPasteImport: T.t('r_fileUpload_dropPasteImport'),
                dropPaste: T.t('r_fileUpload_dropPaste'),
                browse: T.t('r_fileUpload_browse'),
                uploadComplete: T.t('r_fileUpload_uploadComplete'),
                resumeUpload: T.t('r_fileUpload_resumeUpload'),
                pauseUpload: T.t('r_fileUpload_pauseUpload'),
                retry: T.t('r_fileUpload_retryUpload'),
                xFilesSelected: {
                    0: T.t('r_fileUpload_xFilesSelected'),
                    1: T.t('r_fileUpload_xFilesSelected')
                },
                uploading: T.t('r_fileUpload_uploading'),
                complete: T.t('r_fileUpload_complete'),
                showProgressDetails: T.t('r_fileUpload_showProgressDetails'),
                cancelUpload: T.t('r_fileUpload_cancelUpload')
            }
        },
        keyIds: [{ fileUploadKey: '', htmlRender: <></> }],
        isFileUpload: false,
        uppy: Uppy as any
    };

    constructor(props: any) {
        super(props);
        this.handleFileExists = this.handleFileExists.bind(this);
        this.handleModalClose = this.handleModalClose.bind(this);
    }

    public componentWillMount = () => {
        this.setUppyDashboard();
    };

    setComplete = () => {
        this.setState({ isFileUpload: true });
        if (this.props.triggerFileUpload) {
            this.props.triggerFileUpload(this.state.uppy);
        }
    };

    componentDidMount() {
        this.state.uppy.on('complete', (result: any) => this.setComplete());
    }

    handleFileExists() {
        // uppy de dosya varsa true|false dondur - formik yada isFileExists parametresine
        if (this.state.uppy) {
            const isUppyFileExists = Object.keys(this.state.uppy.state.files).length ? true : false;
            if (this.props.formik) {
                this.props.formik.setFieldValue('fileUploaded', isUppyFileExists);
            } else if (this.props.isFileExists) {
                this.props.isFileExists(isUppyFileExists);
            }
        }
    }

    public setUppyDashboard = () => {
        let restrictions: any;
        if (this.props.activityType && this.props.activityType === ActivityTypeEnums.VirtualClass) {
            restrictions = {
                maxFileSize: this.props.maxFileSize,
                minNumberOfFiles: 1,
                allowedFileTypes: window.appSettings.PerculusFileUploadAllowedTypes.split(',')
                    ? window.appSettings.PerculusFileUploadAllowedTypes.split(',')
                    : this.props.fileTypes
                        ? this.props.fileTypes
                        : window.appSettings.FileUploadAllowedTypes.split(',')
            };
        } else {
            restrictions = {
                maxFileSize: this.props.maxFileSize,
                minNumberOfFiles: 1,
                allowedFileTypes: this.props.fileTypes ? this.props.fileTypes.split(',') : window.appSettings.FileUploadAllowedTypes.split(',')
            };
        }

        if (this.props.maxSelectedFileCount) {
            Object.assign(restrictions, { maxNumberOfFiles: this.props.maxSelectedFileCount });
        }

        const uppyOptions: Partial<any> = {
            id: this.props.fileInputKey,
            restrictions,
            metaFields: [],
            target: Dashboard,

            debug: true,
            locale: this.state.locale,
            autoProceed: false,
            trigger: '#uppy-select-files',
            inline: false,
            showLinkToFileUploadResult: true,
            showProgressDetails: true,
            hideUploadButton: false,
            hideRetryButton: false,
            hidePauseResumeButton: true,
            hideCancelButton: false,
            hideProgressAfterFinish: false,
            note: null,
            closeModalOnClickOutside: true,
            closeAfterFinish: true,
            disableStatusBar: false,
            disableInformer: false,
            disableThumbnailGenerator: false,
            disablePageScrollWhenModalOpen: true,
            animateOpenClose: true,
            proudlyDisplayPoweredByUppy: false,
            showSelectedFiles: true,
            browserBackButtonClose: true,
            bundle: false,
            onBeforeFileAdded: (currentFile: { name: string }, files: Record<string, Uppy.UppyFile>) => {
                const isDuplicate = Object.values(files).some((file:any) => 
                    file.name === currentFile.name
                  );
                  if (isDuplicate) {
                    this.state.uppy.info(T.t('r_file_duplicated_name'), 'error', 3000);
                    return false; 
                  }
                  return true;
            }
        };
        this.state.uppy = Uppy(uppyOptions).use(XHRUpload, {
            endpoint: window.appSettings.API_URL + window.appSettings.FILEUPLOAD_PATH,
            headers: {
                authorization: 'Bearer ' + _common.GetAuthLocalStorage().access_token
            }
        });

        if (this.props.activityType) {
            this.state.uppy.setMeta({
                fileUploadId: this.props.fileInputKey ? this.props.fileInputKey : Guid.create().toString(),
                isCardImage: this.props.isCardImage ? this.props.isCardImage : false,
                activityType: this.props.activityType
            });
        } else {
            this.state.uppy.setMeta({
                fileUploadId: this.props.fileInputKey ? this.props.fileInputKey : Guid.create().toString(),
                isCardImage: this.props.isCardImage ? this.props.isCardImage : false
            });
        }

        this.state.uppy.on('upload-success', (file: any, response: any) => {
            if (this.props.type === 'assignment') {
                const statusBarElement = document.querySelector('.uppy-StatusBar-content');
                if (statusBarElement) {
                    const additionalStatusMessage = document.createElement('span');
                    additionalStatusMessage.textContent = T.t('r_save_button_submit_assignment');;
                    additionalStatusMessage.style.color = 'black';
                    additionalStatusMessage.style.fontWeight = 'bold';
                    statusBarElement.appendChild(additionalStatusMessage);
                }
            }

            if (this.props.isDeletableAfterUpload === undefined || this.props.isDeletableAfterUpload === true) {
                this.addDeleteButton(file);
            }
            this.handleFileExists();
            if (this.props.afterUploaded) {
                this.props.afterUploaded(file);
            }

            if (this.props.afterFileUploadChoice && this.props.choice !== undefined && this.props.formik) {
                this.props.afterFileUploadChoice(file, this.props.choice, this.props.formik, this.props.fileInputKey);
            }
           
        });
        
       
        this.state.uppy.on('file-added', (file: {name: string, id: string}) => {
            if(this.props.files)
            {
                const fileNameParts = file.name.split('.');
                const extension = fileNameParts.pop(); 
                const baseName = fileNameParts.join('.'); 
            
                const sanitizedBaseName = baseName.replace(/[\s.()]/g, '_')+"."+extension;

                if(this.props.files?.filter((item:any) => item.fileName === sanitizedBaseName).length>0)
                {
                    this.state.uppy.removeFile(file.id);
                    this.state.uppy.info(T.t('r_file_duplicated_name', { 0: this.props.maxSelectedFileCount }), 'error', 3000);
                }
            }
                // eger maksimum dosya sayısını gectiyse dosyayı ekleme
            if (this.props.maxSelectedFileCount && this.state.uppy.getFiles().length > this.props.maxSelectedFileCount) {
                this.state.uppy.removeFile(file.id);
                this.state.uppy.info(T.t('r_max_selected_file_count', { 0: this.props.maxSelectedFileCount }), 'error', 3000);
            }

        });
    };

    componentDidUpdate(prevProps: IFileUpload) {
        if (prevProps.willDeleteFile !== this.props.willDeleteFile && this.props.willDeleteFile) {
            this.onClickDeleteFileFromUppy(this.props.willDeleteFile);
        }
    }

    onClickDeleteFileFromUppy = (file: any) => {
        const data = {
            fileUploadId: file.meta.fileUploadId,
            fileName: file.name,
            isCardImage: this.props.isCardImage
        };
        this.toggleBlurFileItem(file.id, true);
        void this.apiRequestDeleteFile(data, file.id).then(() => {
            if (this.props.afterDeleted) {
                this.props.afterDeleted();
            }

            if (this.props.afterFileDeleteChoice && this.props.choice !== undefined) {
                this.props.afterFileDeleteChoice(this.props.choice, this.props.formik);
            }
        });
    };

    async apiRequestDeleteFile(data: any, fileId: string) {
        try {
            let isError = false;
            let errorList: any;
            const pageData = await _fileService
                .RequestFileDeleteAsync({ data })
                .then((responseData: Response) => {
                    return responseData;
                })
                .then((responseData: Response) => {
                    if (responseData.status !== 200) {
                        isError = true;
                    }
                    return responseData.json();
                })
                .then(response => {
                    if (isError) {
                        errorList = response;
                    }
                });
            if (isError) {
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                });
            }
            if (!isError) {
                // dosyayı arayüzden kaldır
                const uppyFileItemHtml = document.getElementById('uppy_' + fileId);
                uppyFileItemHtml!.parentNode!.removeChild(uppyFileItemHtml!);
                this.state.uppy.removeFile(fileId);
                this.handleFileExists();
            }
        } catch (error: any) {
            Notification.setNotification('error', '' + error, 'topRight');
        }
    }

    toggleBlurFileItem(fileId: string, isBlur: boolean) {
        if (fileId) {
            const uppyFileItemHtml = document.getElementById('uppy_' + fileId);
            if (uppyFileItemHtml) {
                uppyFileItemHtml.style.opacity = isBlur ? '0.6' : '1';
            }
        }
    }

    addDeleteButton(file: any) {
        if (file) {
            const uppyFileItemHtml = document.getElementById('uppy_' + file.id);
            if (uppyFileItemHtml) {
                const _htmlDeleteIcon = (
                    // tslint:disable-next-line
                    <i
                        onClick={() => this.onClickDeleteFileFromUppy(file)}
                        className={'material-icons del-icon del-icon-color del-icon-margin ' + file.name}
                        style={{ cursor: 'pointer' }}
                    >
                        delete
                    </i>
                );
                ReactDOM.render(<>{_htmlDeleteIcon}</>, uppyFileItemHtml);
            }
        }
    }

    handleModalClose = () => {
        if (this.props.handleModalClose && typeof this.props.handleModalClose === 'function') {
            this.props.handleModalClose(this.state.uppy);
        }
    };

    public render() {
        const returnHtml = this.state.keyIds.filter(f => f.fileUploadKey === this.props.fileInputKey);
        if (returnHtml.length > 0 && !this.props.isModal) {
            return (
                <div className="scrollable-container">
                    {returnHtml[0].htmlRender}
                </div>
            );
        }
         else {
            if(this.props.isSimulate){
                return;
            }
            if (this.props.isModal) {
                return (
                    <DashboardModal
                        key={this.props.fileInputKey}
                        uppy={this.state.uppy}
                        closeModalOnClickOutside={true}
                        open={!!this.props.modalOpen}
                        onRequestClose={this.handleModalClose}
                        proudlyDisplayPoweredByUppy={false}
                    />
                );
            } else {
                const returnData = {
                    fileUploadKey: this.props.fileInputKey,
                    htmlRender: (
                        <Dashboard
                            key={this.props.fileInputKey}
                            uppy={this.state.uppy}
                            proudlyDisplayPoweredByUppy={false}
                            height={this.props.height}
                            width={1000}
                        />
                    )
                };
                this.state.keyIds.push(returnData);
                return returnData.htmlRender;
            }
        }
    }
}
const mapStateToProps = (state: IAppState, ownProps: IFileUpload) => {
    if (!state) {
        return ownProps;
    }
    const newProps: IFileUpload = Object.assign({}, ownProps, {
        isSimulate: state.login.identitiy.isSimulate,
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    return false;
};

const FileUpload = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(CFileUpload);

export default FileUpload;
